class StickyHeader extends HTMLElement {
  constructor () {
    super()

    this.style.setProperty('--header-height', `${this.offsetHeight}px`)

    this.setupListeners()
  }

  connectedCallback () {
    this.isTicking = false
    this.lastKnownY = window.scrollY
    this.offsetTrackedY = 0
    this.scrollOffset = 50
    this.safeZone = 50
    this.scrollDirection = ''
  }

  setupListeners () {
    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)
    this.onScroll = this.onScroll.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })
    window.addEventListener('resize', (event) => {
      this.style.setProperty('--header-height', `${this.offsetHeight}px`)
    })
  }

  onScroll () {
    const previouslyKnown = this.lastKnownY
    const previousDirection = this.scrollDirection

    this.lastKnownY = window.scrollY
    this.scrollDirection = previouslyKnown < this.lastKnownY ? 'down' : 'up'

    if (previousDirection !== this.scrollDirection) {
      this.offsetTrackedY = this.lastKnownY
    }

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.style.setProperty('--header-height', `${this.offsetHeight}px`)
    this.setScrolled()
    this.setShowSearch()
  }

  setScrolled () {
    this.classList.toggle(this.dataset.classScrolled, this.shouldBeScrolled)
    const bodyEl = document.body

    bodyEl.classList.toggle('lyt-Theme-scrolled', this.shouldBeScrolled)
    bodyEl.classList.toggle('lyt-Theme-scrolled-up', this.shouldBeScrolled && this.scrollDirection === 'up')
  }

  setShowSearch () {
    this.classList.toggle(this.dataset.classShowSearch, this.showShowSearch)
  }

  get shouldBeScrolled () {
    return this.lastKnownY >= this.safeZone
  }

  get showShowSearch () {
    if (this.lastKnownY < this.safeZone) {
      return false
    }

    if (this.scrollDirection === 'down') {
      return !this.isOverOffset
    } else if (this.scrollDirection === 'up') {
      return this.isOverOffset
    }
  }

  get isOverOffset () {
    if (this.scrollDirection === 'down') {
      return this.lastKnownY >= this.offsetTrackedY + this.scrollOffset
    } else if (this.scrollDirection === 'up') {
      return this.lastKnownY <= this.offsetTrackedY - this.scrollOffset
    }
  }
}

if (!customElements.get('sticky-header')) {
  customElements.define('sticky-header', StickyHeader)
}
